/**
 * Təhsil və tədris müəssisələrinin siyahısı.
 * Mənbə: docs/Təhsil - tədris və aidiyyəti müəssisələr və mərkəzlərin siyahısı.pdf
 * Siyahı dəyişəndə həmin sənəddən yenidən çıxarılmalıdır.
 */
export const SCHOOLS = [
  "LANDAU SCHOOL Təhsil Kompleksi QSC",
  "Heydər Əliyev Adına Müasir Təhsil Kompleksi MMC",
  "Baku International School",
  "The International School of Azerbaijan (“TİSA” Təhsil Kompleksi MMC)",
  "Baku Oxford School- “Baku Oksford Skul” tam orta ümumtəhsil məktəbi MMC",
  "European Azerbaijan School (Avropa Azərbaycan Məktəbi Təhsil Kompleksi MMC)",
  "İdrak Liseyi",
  "“Xəzər Universiteti Dünya Məktəbi” MMC",
  "British School in Baku",
  "“Azerbaijan British College” Təhsil Kompleksi",
  "Bakı Modern Təhsil Kompleksi",
  "“Oxbridge Academy” ümumtəhsil müəssisəsi MMC",
  "“SABIS SUN Beynəlxalq Məktəbi” MMC",
  "“XXI Əsr Beynəlxalq Təhsil və İnnovasiya Mərkəzi” MMC",
  "Müasir İnnovasiyalar Liseyi (“MİL” tam orta ümumtəhsil məktəbi MMC)",
  "“Bakı Beynəlxalq Təhsil Kompleksi” MMC",
  "“Simurq Liseyi Təhsil Kompleksi” MMC",
  "Sabah School",
  "Western Caspian University High School",
  "Yaşam Beynəlxalq Məktəbi",
  "Beynəlxalq Maarif Məktəbləri (İMSA Maarif Schools MMC)",
  "“Hədəf Liseyi” MMC",
  "Bakı İstanbul Liseyi (“İstanbul Liseyi” MMC)",
  "“Evrika Liseyi” MMC",
  "“Kaspi Liseyi” ümumtəhsil məktəbi",
  "Türk Dünyası Bakı Atatürk Liseyi",
  "Azərbaycan Bakı Türk Anadolu Liseyi",
  "“Hədəf Kursları” MMC",
  "Kainat Tədris Mərkəzi",
  "Kaspi Təhsil Şirkəti",
  "Uğur Kursları",
  "STİMUL Kursları",
  "Zirvə Tədris Mərkəzi",
  "Lider Hazırlıq Mərkəzi",
  "Dərs Evi",
  "TeachMe Academy",
  "Brain Academy",
  "IT Step Academy Azerbaijan",
  "“Barattson” MMC",
  "Tech Academy",
  "“Code Academy” MMC",
  "“Matrix Academy” MMC",
  "SABAH.HUB İnnovasiya Mərkəzi",
  "CELT Colleges",
  "Baku City Academy",
  "IT Brains Academy",
  "Jalali Business & Language School",
  "Study in UK / Eduguide Azerbaijan",
  "Marmara Group Azerbaijan",
  "Studynet Azerbaijan",
  "Azeri Student",
  "WEC Azerbaijan (World Education Counseling)",
  "Baku Education Information Center (BEIC)",
  "Osmanlı Şirkətlər Qrupu",
  "EL-BE Group",
  "\"EGE Group\" Xaricdə Təhsil Mərkəzi",
  "Akare Xaricdə Təhsil Mərkəzi",
  "Mega Group",
  "Akademi Global",
  "Global Learning Center",
  "Oğuz EDU Xaricdə Təhsil Şirkəti",
  "“Shane Academy” MMC",
  "Uniway Education",
  "Lingua Center Baku",
  "Goethe İnstitutu",
  "Institut Français Azerbaïdjan IFA",
  "Baku Language Center (BLC)",
  "Avropa Təhsil Mərkəzi",
  "TR Education (Türkiyədə Təhsil Mərkəzi)",
  "\"EDU Company\" Təhsil Şirkəti",
  "Global Study Azerbaijan",
  "GRBS Study Abroad",
  "BestStudy",
  "Edudistance",
  "Upper Education",
  "\"ARI\" Xaricdə Təhsil Mərkəzi",
  "ROOF Academy",
  "Edumax Xaricdə Təhsil Mərkəzi",
  "Beynəlxalq Təhsil Mərkəzi",
  "Edde Global",
  "Ivy Hub",
  "\"Berlin Academy\" MMC",
  "iSchool",
  "Griffin Education Center",
  "Time Academy",
  "Piramida Təhsil Mərkəzi",
  "IT Innovations",
  "Star Colleges",
  "İstanbul Group Xaricdə Təhsil Şirkəti",
  "ADA Academy Təhsil Mərkəzi",
  "INK Academy",
  "“DIV Academy” MMC",
  "VIP Academy",
  "Academor",
  "Edulandiya",
  "Garibchi",
  "Interstudent",
  "British Academy — \"English UK\"",
  "Passport Academy",
  "Educolour Xaricdə Təhsil Şirkəti",
  "Cleverest Academy",
  "FD Education",
  "EDUSTART Xaricdə Təhsil Xidməti",
  "Edu Style",
  "Qafqaz Təhsil Mərkəzi",
  "“AZSTUDY” MMC",
  "Sakhavatoglu Company MMC",
  "KİDS Academy by British School",
  "Global Learning & Development Partners (GLDP)",
  "Ted Academy",
  "Xəmsə Tədris Mərkəzi",
];

/** Siyahıda olmayan müəssisə üçün — əl ilə yazmağa imkan verir */
export const OTHER = "__other__";

export default SCHOOLS;
